<template lang="pug">
  section.featured-collections
    h1.featured-collections__title {{ title }}
    p.featured-collections__body {{ body }}
    .featured-collections__carousel-container
      carousel.carousel--featured-collections(
        :slides-to-show="['mobile', 'tablet'].includes($mq) ? 1.5 : 4.3"
        arrows
      )
        slide.slide--featured-collections(
          v-for="(collection) in collections"
          :key="`${collection.title}`"
        )
          collection-tile(:collection="collection")
</template>

<script>
  import Carousel from 'scripts/components/basic/Carousel.vue';
  import Slide from 'scripts/components/basic/Slide.vue';
  import CollectionTile from 'scripts/components/sections/CollectionTile.vue';
  import Icon from 'scripts/components/basic/Icon.vue';
  import 'swiper/swiper.scss';

  export default {
    components: {
      Carousel,
      Slide,
      CollectionTile,
      Icon,
    },
    props: {
      title: String,
      body: String,
      collections: {
        type: Array,
        default: () => [],
      },
    },
  };
</script>

<style lang="scss">
  .featured-collections {
    position: relative;
    padding: $spacing-unit * 15 0 $spacing-unit * 29 0;

    @include desktop-up {
      padding: $spacing-unit * 8 0 $spacing-unit * 41 0;
    }
  }

  .featured-collections__title {
    position: relative;
    z-index: index($featured-collections, content);
    margin: 0 0 $spacing-unit * 4 0;
    padding: 0 $spacing-unit * 4;
    font-size: rem(28);
    line-height: rem(32);
    text-align: center;

    @include desktop-up {
      margin: 0 0 $spacing-unit * 4 $spacing-unit * 39;
      padding: 0;
      font-size: rem(36);
      line-height: rem(40);
      text-align: left;
    }
  }

  .featured-collections__body {
    position: relative;
    z-index: index($featured-collections, content);
    margin: 0 0 $spacing-unit * 6 0;
    padding: 0 $spacing-unit * 4;
    text-align: center;

    @include desktop-up {
      margin: 0 0 $spacing-unit * 13 $spacing-unit * 39;
      padding: 0;
      max-width: $spacing-unit * 108;
      font-size: rem(18);
      line-height: rem(24);
      text-align: left;
    }
  }

  .featured-collections__carousel-container {
    position: relative;
    z-index: index($featured-collections, content);
    padding-left: $spacing-unit * 4;
    width: 100%;
    overflow: hidden;

    @include desktop-up {
      padding-left: $spacing-unit * 10;
    }
  }
</style>
